
import { useEffect, useState } from 'react';
import { VapiWidget } from '@vapi-ai/client-sdk-react';
import "./ChatBot.scss";

const ChatBot = ({ language }) => {

  const [config, setConfig] = useState(null);

  useEffect(() => {
    const phoneNumber = localStorage.getItem("session_user_phonenumber");
    const FirstName = localStorage.getItem("session_user_firstname");

    const session_enChatPlaceholder = localStorage.getItem("session_enChatPlaceholder");
    const session_enEmptyChatMessage = localStorage.getItem("session_enEmptyChatMessage");
    const session_enMainLabel = localStorage.getItem("session_enMainLabel");
    const session_deChatPlaceholder = localStorage.getItem("session_deChatPlaceholder");
    const session_deEmptyChatMessage = localStorage.getItem("session_deEmptyChatMessage");
    const session_deMainLabel = localStorage.getItem("session_deMainLabel");

    // Check if phone number is not blank and exactly 10 digits
    const isValidPhoneNumber = phoneNumber && /^\d{10}$/.test(phoneNumber);

    if (isValidPhoneNumber) {
      setConfig({
        assistantOverrides: {
          variableValues: {
            phoneNumber,
            FirstName,
          },
        },
        publicKey: "8e100f85-ab6b-48f5-82df-6b811ed320fc",
        assistantId: language === "en" ? "cd5b08a2-16ae-482d-8be3-eaf5dc5f9fac" : "e469abb5-69e5-4b6f-b4fe-413b6fd29a55",
        mode: "chat",
        theme: "dark",
        size: "compact",
        position: "bottom-right",
        mainLabel: language === "en" ? session_enMainLabel : session_deMainLabel,
        emptyChatMessage: language === "en" ? session_enEmptyChatMessage : session_deEmptyChatMessage,
        chatPlaceholder: language === "en" ? session_enChatPlaceholder : session_deChatPlaceholder,
      });
    } else {
      console.log('Chatbot not shown: Invalid phone number format');
    }
  }, [language]);

  return <VapiWidget {...config} />
}

export default ChatBot;